import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import { default as Modal2, default as Toast } from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BiBadgeCheck } from "react-icons/bi";
import { GoProject } from "react-icons/go";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineLanguage } from "react-icons/md";
import { IoCall } from "react-icons/io5";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import { UseConsultant } from "../context/ConsultantContext";
import BillDeskPay from "./BillDeskPay";
import FreeUsed from "./FreeUsed";
import ReviewBadge from "./ReviewBadge";
import ToastMsg from "./Toast";
import UserDetailModal from "./UserDetailModal";
import BgImg from "../images/Image only22.png";
import UpBtn from "../images/uparrow.gif"
import call_Logo from "../images/call_5.png"
import { PiPhoneCallDuotone } from "react-icons/pi";

// import WalletImg from "../images/Wallet call1.png";
// import FixedDuration1 from "../images/Fixed duration1.png";
// import FixedDuration2 from "../images/Fixed duration2.png";

const SearchList = ({ filteredPersons, service }) => {
  const {
    setAlertFunction,
    handleWalletCall,
    handleFreeCall,
    walletBalance,
    setWalletBalance,
  } = UseConsultant();
  console.log("filteredPersons", filteredPersons);
  console.log("filteredPersons", filteredPersons.length);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = window.localStorage.getItem("i18nextLng");
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const consultantId = window.sessionStorage.getItem("consultantId");
  const uuid = window.sessionStorage.getItem("userId");
  const duration = window.sessionStorage.getItem("AudioCallDuration");
  const [profList, setProfList] = useState([]);
  console.log("profList", profList);
  const [waitingTime, setWaitingTime] = useState();
  const [consulName, setConsulName] = useState();
  const [selectedConsultant, setSelectedConsultant] = useState({});
  const [selectedConsultantService, setSelectedConsultantService] = useState(
    service,
  );
  const [defaultAudioOffer, setDefaultAudioOffer] = useState({});
  const [defaultAudioOffer15, setDefaultAudioOffer15] = useState({});
  const [defaultAudioOffer30, setDefaultAudioOffer30] = useState({});
  let subtitle;
  const [loading, setLoading] = useState(false);
  const [selectedAudioOffer, setSelectedAudioOffer] = useState(7);
  const [activeServiceList, setActiveServiceList] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [consultantServiceList, setConsultantServiceList] = useState([]);
  const [formData, setFormData] = useState({
    duration: 0,
    price: 0,
  });
  const [freeCallStatus, setFreeCallStatus] = useState("");
  console.log("profList", profList);
  const [bookingStatus, setBookingStatus] = useState("");
  const [loadingId, setLoadingId] = useState(null);

  console.log("consultantId", consultantId);

  const { consultantUuid } = location.state || {};

  useEffect(() => {
    setAlertFunction(alert);
  }, [setAlertFunction]);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  // const alert = (msg) => {
  //   setMessage(msg);
  //   setToastTrigger((prev) => prev + 1);
  // };

  const alert = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setToastTrigger((prev) => prev + 1);
  };

  // Consultant Busy MODAL
  const [toast, setToast] = useState(false);

  const openToastModal = (value) => {
    console.log("value", value);
    setToast(true);
    // setWaitingTime(Math.round(value.waitingTime));
    setWaitingTime(value);
  };

  const closeTosastBtn = () => {
    setToast(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  //modal inside show image 
  const [walletAmount, setWalletAmount] = useState(0);
  const [talkTime, setTalkTime] = useState(0);

  const getWalletBalance = async (ratePerMin) => {
    console.log("getWalletBalance called", ratePerMin);

    try {

      const res = await vasthuUrl.post(
        `vasthu/check-call-eligibility`,
        {
          userUuid: userId,
          proUuid: sessionStorage.getItem("consultantId"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("API FULL RESPONSE", res.data);

      const balance = res.data.balance ?? res.data.walletBalance ?? 0;

      const rate = ratePerMin || 1;

      const minutes = Math.floor(balance / rate);

      setWalletAmount(balance);
      setTalkTime(minutes);

    } catch (error) {
      console.log("Wallet fetch error:", error);
    }

  };

  //Audio call duration MODAL
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    console.log("afterOpenModal");
  }

  function closeModal() {
    setIsOpen(false);
    window.sessionStorage.removeItem("pendingAction");
  }

  //Service MODAL
  const [serviceModal, setServiceModal] = React.useState(false);

  function OpenServiceModal() {
    setServiceModal(true);
  }

  function afterServiceModal() {
    console.log("afterOpenModal");
  }

  function closeServiceModal() {
    setServiceModal(false);
    window.sessionStorage.removeItem("pendingAction");
  }

  //Check Booking Status
  const [checkBookStatus, setCheckBookStatus] = useState(false);

  const openCheckBookStatus = () => {
    setCheckBookStatus(true);
  };

  const closeCheckBookStatus = () => {
    setCheckBookStatus(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  //Check Booking Status
  const [callType, setCallType] = useState(false);

  const openCallType = () => {
    setCallType(true);
  };

  const closeCallType = () => {
    setCallType(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  const [consultantUuids, setConsultantUuids] = useState(null);
  console.log("consultantUuids", consultantUuids);

  //Free Service Used Modal
  const [usedFreeModal, setUsedFreeModal] = useState(0);

  //Free User Details Modal
  const [userDetailsModal, setUserDetailsModal] = useState(0);

  // booking - end
  useEffect(() => {
    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores", res);
        setDefaultAudioOffer({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio15`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores15", res);
        setDefaultAudioOffer15({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer15({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio30`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores30", res);
        setDefaultAudioOffer30({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer30({}));
  }, []);

  useEffect(() => {
    setLoading(true);
    if (token) {
      try {
        vasthuUrl
          .get(`/vasthu/getvasthuservices`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("services_list" + res.data);
            let consultations = res.data.filter(
              (obj) => obj.serviceType == "CONSULTATION",
            );
            console.log(
              "services_list_consultaions" + consultations[0].serviceType,
            );
            setServiceData(consultations);
          });

        vasthuUrl
          .get(`/info/professional/consultantdetails`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setProfList(res.data);
            setLoading(false);
          });
      } catch (e) {
        alert("SERVER ERROR");
        setMessageType("error");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [token]);

  const executePendingAction = () => {
    const pendingAction = window.sessionStorage.getItem("pendingAction");
    const userId = window.sessionStorage.getItem("userId");
    const token = window.sessionStorage.getItem("token");
    const consultantId = window.sessionStorage.getItem("consultantId");
    const consultantName = window.sessionStorage.getItem("consultantName");
    const consultantType = window.sessionStorage.getItem("consultantType");

    if (!pendingAction || !consultantId || !consultantType) return;

    console.log("executing pendingAction:", pendingAction);

    if (pendingAction === "ConsultantHomeBook") {
      getConsutantServices(consultantId);
      setConsulName(consultantName);
      window.sessionStorage.removeItem("pendingAction");
    } else if (pendingAction === "HomeChatorCall") {
      setConsulName(consultantName);

      if (consultantType === "freeCall" || consultantType === "freeChat") {
        CheckFreeStatus(consultantId, consultantType);
      } else {
        getCallAndChatService(userId, consultantId, consultantType);
      }

      window.sessionStorage.removeItem("pendingAction");
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      executePendingAction();
    }
  }, []);

  useEffect(() => {
    if (userId !== null) {
      try {
        vasthuUrl
          .get(`/vasthu/user/getuserfreecallstatus/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setFreeCallStatus(res.data.freeCallUsed);
            if (res.data.freeCallUsedstatus == "Completed") {
              setUsedFreeModal((prev) => prev + 1);
            }
          });
      } catch (e) {
        console.log("service", e);
      }
    }
  }, [userId]);

  const checkLoginAndGetConsultant = (id, name, type, rate) => {
    window.sessionStorage.setItem("consultantId", id);
    window.sessionStorage.setItem("consultantName", name);
    window.sessionStorage.setItem("consultantRate", rate);
    window.sessionStorage.setItem("consultantType", type);
    if (window.sessionStorage.getItem("token") == null) {
      if (type == "Book") {
        window.sessionStorage.setItem("pendingAction", "ConsultantHomeBook");
      } else if (
        type == "Call" ||
        type == "Chat" ||
        type == "freeCall" ||
        type == "freeChat"
      ) {
        window.sessionStorage.setItem("pendingAction", "HomeChatorCall");
      }
      alert(t("USR.LOG.MSG"));
      setMessageType("error");
      setTimeout(() => {
        setLoadingId(null);
        navigate("/login");
      }, 3000);
    } else {
      if (type === "freeCall" || type === "freeChat") {
        CheckFreeStatus(id, type);
      } else if (type === "Call" || type === "Chat") {
        getCallAndChatService(userId, id, type);
      } else if (type === "Book") {
        getConsutantServices(id);
      }
      setConsulName(name);
      setLoadingId(null);
    }
  };

  const getCallAndChatService = (userId, consultantId, type) => {
    try {
      vasthuUrl
        .post(
          `vasthu/check-call-eligibility`,
          {
            userUuid: userId,
            proUuid: consultantId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          console.log("res.data", res.data);
          if (res.data.status == "INSUFFICIENT_BALANCE") {
            if (res.data.balance == 0) {
              alert(t("USR.INSF.BAL.ALRT.MSG"));
              setMessageType("error");
              window.sessionStorage.setItem("consultantId", consultantId);
              window.sessionStorage.setItem("consultantType", type);
              window.sessionStorage.setItem("returnurl", location.pathname);
              window.sessionStorage.setItem("pendingAction", "HomeChatorCall");
              setTimeout(() => {
                navigate("/walletoffer");
              }, 3000);
            } else {
              alert(
                `${t("USR.BAL.MINCOST.CONST.ALT")} ₹${res.data.amountNeeded
                }  ${t("USR.THIS.CONSULTANT")}.`,
              );
              setMessageType("error");
              window.sessionStorage.setItem("consultantId", consultantId);
              window.sessionStorage.setItem("consultantType", type);
              window.sessionStorage.setItem("returnurl", location.pathname);
              window.sessionStorage.setItem("pendingAction", "HomeChatorCall");
              setTimeout(() => {
                navigate("/walletoffer");
              }, 3000);
            }
            window.sessionStorage.removeItem("pendingAction");
            console.log("Clear -> pendingAction");
          } else if (res.data.message == "NOT A VALID USER") {
            alert(t("USR.INSF.BAL.ALRT.MSG"));
            setMessageType("error");
            setTimeout(() => {
              navigate("/walletoffer");
            }, 3000);
          } else if (res.data.status == "CONSULTANT_IN_CALL") {
            openToastModal(res.data.expectedToBeFreeInMinutes);
          } else if (res.data.status == "DONT_CALL") {
            setBookingStatus(res.data);
            openCheckBookStatus();
          } else if (res.data.status === "CALL_ALLOWED") {
            if (type === "Chat") {
              setUserDetailsModal((prev) => prev + 1);
              return;
            }

            if (type === "Call") {
              handleWalletCall(); // ✅ Always open call type first
              return;
            }

            if (type === "Duration") {
              openModal();
              return;
            }

            if (type === "freeCall") {
              handleFreeCall(); // ✅ direct free call
              return;
            }

            if (type === "freeChat") {
              setUserDetailsModal((prev) => prev + 1);
              return;
            }
          }
        });
    } catch (e) {
      console.log("e", e);
    }
  };

  const handleProceed = () => {
    const consultantType = window.sessionStorage.getItem("consultantType");
    const country = window.sessionStorage.getItem("country");

    if (consultantType == "Chat") {
      setUserDetailsModal((prev) => prev + 1);
    } else {
      if (country == "0") {
        handleWalletCall(); //Limited Duration
      } else {
        setUserDetailsModal((prev) => prev + 1);
      }
    }
    closeCheckBookStatus();
  };

  const handleProceedCall = (type) => {
    const consultantId = window.sessionStorage.getItem("consultantId");
    if (!consultantId) return;

    if (type === "free") {
      getCallAndChatService(userId, consultantId, "freeCall");
    } else if (type === "wallet") {
      getCallAndChatService(userId, consultantId, "Call");
    } else if (type === "duration") {
      getCallAndChatService(userId, consultantId, "Duration");
    }

    closeCallType();
  };

  const CheckFreeStatus = (id, type) => {
    const userId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    const country = window.sessionStorage.getItem("country");

    if (!userId || !token) {
      console.log("User not logged in - skipping CheckFreeStatus");
      return;
    }

    // Optional: Remove pendingAction only after it's processed
    window.sessionStorage.removeItem("pendingAction");
    try {
      vasthuUrl
        .get(`/vasthu/user/getuserfreecallstatus/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          const freeCallStatus = res.data.freeCallUsed;
          console.log("freeCallStatus", freeCallStatus);
          if (freeCallStatus) {
            setUsedFreeModal((prev) => prev + 1);
          } else {
            if (type == "freeCall") {
              if (country == "0") {
                handleFreeCall();
              } else {
                setUserDetailsModal((prev) => prev + 1);
              }
            } else if (type == "freeChat") {
              setUserDetailsModal((prev) => prev + 1);
              console.log("freeChat alert call");
            }
          }
        });
    } catch (e) {
      console.log("service", e);
    }
  };

  const getConsutantServices = (uuid) => {
    try {
      vasthuUrl
        .get(`vasthu/getvasthuservicesbyconsultant/${uuid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log("services_list" + res.data);
          setConsultantServiceList(res.data);
          setSelectedConsultant(uuid);
          if (selectedConsultantService == null) {
            OpenServiceModal();
          } else {
            CheckConsultant(uuid);
          }
        });
    } catch (e) {
      console.log("service", e);
    }
  };

  const CheckConsultant = (uuid) => {
    window.sessionStorage.removeItem("pendingAction");
    if (typeof selectedConsultantService !== "undefined") {
      let value = profList.find(
        (x) => x.consultantUuid == (selectedConsultant || uuid),
      );
      window.sessionStorage.setItem(
        "consultantDetail",
        JSON.stringify({ value }),
      );
      navigate("/customerpricing", { state: selectedConsultantService });
    } else {
      alert("Please Select a service");
      setMessageType("error");
    }
  };

  const payHandler = (txn) => {
    console.log("pay response out", txn);
    vasthuUrl
      .post(
        "vasthu/user/bdpaymentresponseui",
        { txn: txn.txnResponse.transaction_response },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        console.log("txnres", res.data);
        if (res.data.transaction_error_type === "success") {
          console.log("Saving payment_response ....", txn);

          vasthuUrl
            .post("vasthu/user/bdpaymentresponsehandler", txn, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => console.log("after txnsave", res.data))
            .catch((err) => console.log("after txnsave try", err));

          console.log("buying .. subsc");

          setTimeout(() => {
            vasthuUrl
              .post(
                "subscription/buyVasthuOffer",
                {
                  orderId: res.data.orderid,
                  userUuid: userId,
                  offerId: selectedAudioOffer,
                  paymentStatus: true,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                },
              )
              .then((res) => {
                console.log("Payment status changed to true");
                console.log("call audio");
                console.log("afterbuysubscr", res.data);
                try {
                  vasthuUrl.post(
                    `vasthu/user/clicktocall`,
                    {
                      from: consultantId, //"09790580304",
                      to: uuid, //"07092758264",
                      duration: parseInt(duration), //30min
                      subscriptionId: res.data.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    },
                  );
                  console.log("postresponsefrom audio call", res.data);
                  console.log("postresponsefrom audio call", res);
                  if (res.status == 200) {
                    navigate("/audiocallstatus", {
                      state: { callStatus: "USR.CAL.PROCED.BTN" },
                    });
                    console.log(
                      "offerId - on 200 [already register offer] status",
                      res.data.id,
                    );
                    vasthuUrl
                      .get(
                        // `/subscription/useVasthuOffer/${i.id}`,
                        `/subscription/useVasthuOffer/${res.data.id}`,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        },
                      )
                      .then((rs) =>
                        console.log(
                          "offer subscription redeem count used",
                          rs.data.message,
                        ),
                      )
                      .catch((er) =>
                        console.log(
                          "offer subscription redeem count not reduced",
                          er,
                        ),
                      );
                  } else {
                    navigate("/audiocallstatus", {
                      state: { callStatus: "USR.CAL.FAILD.BTN" },
                    });
                  }
                } catch (err) {
                  console.log("SERVER ERROR", err);
                }
              });
          }, 1000);
        } else {
          vasthuUrl
            .post(
              "subscription/buyVasthuOffer",
              {
                orderId: res.data.orderid,
                userUuid: userId,
                offerId: selectedAudioOffer,
                paymentStatus: false,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            )
            .then((res) => {
              console.log("Payment status changed to false");
            });
        }
      });
  };

  const handleBuy1 = async (e) => {
    try {
      console.log("handle_buy1");
      await vasthuUrl
        .post(
          `vasthu/openapi/createorderapi`,
          {
            userUuid: userId,
            offerId: selectedAudioOffer,
            price: formData.price,
            currency: "356",
            returnUrl: "paymentstatusbilldesk",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          console.log("billDesk", res.data);
          BillDeskPay(res.data, payHandler)
            .then((config) => {
              console.log("payout", config);
              window.loadBillDeskSdk(config);
            })
            .catch((err) => console.log("payment initialize error", err));
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handlePsumbit1 = async (event) => {

    if (event) {
      event.preventDefault();
    }

    setLoading(true);

    try {

      const list = await vasthuUrl.get(`/subscription/userActiveOffers/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Audiocall list available", list.data);

      let filteredAudioList = list.data.filter(
        (obj) => obj.offerId > 2
      );

      console.log("filtered audio list", filteredAudioList);

      setActiveServiceList(filteredAudioList);

      console.log("no subscription - please proceed with pay");

      setLoading(false);

      handleBuy1();
      closeCallType();

    } catch (e) {

      alert("CHECK INTERNET CONNECTION");
      setMessageType("error");
      console.log("error from trying subscription list", e);
      setLoading(false);

    }

  };

  const handleDurationRadio = (value) => {

    if (value === 15) {

      window.sessionStorage.setItem("AudioCallDuration", "900");

      setSelectedAudioOffer(defaultAudioOffer15.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer15.offerPrice,
      });

      handlePsumbit1();

    } else if (value === 30) {

      window.sessionStorage.setItem("AudioCallDuration", "1800");

      setSelectedAudioOffer(defaultAudioOffer30.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer30.offerPrice,
      });

      handlePsumbit1();

    } else {

      window.sessionStorage.setItem("AudioCallDuration", "3600");

      setSelectedAudioOffer(defaultAudioOffer.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer.offerPrice,
      });

      handlePsumbit1();

    }

  };

  return (
    <div>
      <ToastMsg msg={message} type={messageType} trigger={toastTrigger} />
      <FreeUsed usedFreeModal={usedFreeModal} walletBalance={walletBalance} />
      <UserDetailModal userDetailsModal={userDetailsModal} />

      <Modal2
        show={modalIsOpen}
        backdrop="static"
        keyboard={false}
        onHide={closeModal}
        className="all_border"
        centered
      >
        <Modal2.Header closeButton className="all_background">
          <h3>Audio Call Duration</h3>
        </Modal2.Header>
        <h3
          className="text-center mt-3"
          ref={(_subtitle) => (subtitle = _subtitle)}
        >
          {t("TXT.SEL.AUD.CAL.DURA.LO")}
        </h3>
        <form onSubmit={handlePsumbit1}>
          <div
            className="text-center"
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
            }}
          >
            <div>
              <label>15 {t("TXT.MIN.LO")}</label>
              {/*  15 min */}
              <input
                type="radio"
                name="duration"
                value={15}
                onChange={handleDurationRadio}
                style={{ marginLeft: "revert" }}
              />
            </div>
            <div>
              <label>30 {t("TXT.MIN.LO")}</label>
              {/*  30 min */}
              <input
                type="radio"
                name="duration"
                value={30}
                onChange={handleDurationRadio}
                style={{ marginLeft: "revert" }}
              />
            </div>
            {/* <input type="submit" /> */}
          </div>
          <Modal2.Footer
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              padding: "5px",
            }}
            className="all_border"
          >
            <Button size="sm" type="submit" className="all_btn">
              {t("USR.VFP.DRP.BTN.SMT")}
            </Button>
            <Button size="sm" onClick={closeModal} className="all_btn">
              {t("TXT.BTN.CAN.LO")}
            </Button>
          </Modal2.Footer>
        </form>
      </Modal2>

      <Modal
        isOpen={serviceModal}
        onAfterOpen={afterServiceModal}
        onRequestClose={closeServiceModal}
        // style={customStyles}
        contentLabel="Select Consultaion Service"
      >
        <h2
          className="text-center all_background"
          ref={(_subtitle) => (subtitle = _subtitle)}
        >
          {t("TXT.SEL.SER.LO")}
        </h2>

        <div
          className="text-center"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <FloatingLabel controlId="min">
            <Form.Select
              aria-label="min"
              size="sm"
              className="form_feild"
              onChange={(e) => {
                console.log("SelectedConsultationService", e.target.value);
                setSelectedConsultantService(e.target.value);
              }}
            >
              <option>{t("TXT.SEL.SER.LO")}</option>
              {consultantServiceList.map((service, index) => (
                <option key={index} value={service.id}>
                  {lang == "en"
                    ? service.serviceName
                    : lang == "ta"
                      ? service.serviceNameTamil
                      : service.serviceNameHindi}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>

          <Button
            size="sm"
            type="submit"
            className="all_btn"
            style={{ width: "100%", marginTop: "8px" }}
            onClick={CheckConsultant}
          >
            {t("USR.VFP.DRP.BTN.SMT")}
          </Button>
        </div>
        <center>
          <Button
            size="sm"
            style={{ width: "100%", marginTop: "8px" }}
            onClick={closeServiceModal}
            className="all_btn"
          >
            {t("TXT.BTN.CAN.LO")}
          </Button>
        </center>
      </Modal>

      <Toast
        show={toast}
        backdrop="static"
        keyboard={false}
        onHide={() => setToast(false)}
        className="all_border"
      >
        <Toast.Header closeButton className="all_background">
          {t("TXT.CON.BSY.LO")}!!!
        </Toast.Header>
        <Toast.Body>
          Hello! <b>{consulName}</b> is currenty busy on another call, please
          bear with us for {waitingTime} minutes{" "}
        </Toast.Body>
        <Toast.Footer>
          <Button className="all_btn" onClick={closeTosastBtn}>
            {t("TXT.CLO.LO")}
          </Button>
        </Toast.Footer>
      </Toast>

      <Modal2
        show={checkBookStatus}
        backdrop="static"
        keyboard={false}
        onHide={closeCheckBookStatus}
      >
        <Modal2.Header className="all_background" closeButton>
          <Modal2.Title>{t("USR.BSY.ALT")}</Modal2.Title>
        </Modal2.Header>
        <Modal2.Body>
          <div>
            {bookingStatus.status === "DONT_CALL" &&
              bookingStatus.allowedTalkTime > 0 ? (
              <>
                {t("USR.THIS.CON.BUSY.TEXT")}{" "}
                <b>{bookingStatus.allowedTalkTime}</b>{" "}
                {t("USR.CONS.CALCOMG.MSG")}
              </>
            ) : (
              t("USR.DONT.CL.MSG")
            )}
          </div>
        </Modal2.Body>
        <Modal2.Footer className="d-flex justify-content-evenly">
          <Button className="all_btn1" onClick={closeCheckBookStatus}>
            {t("TXT.CLO.LO")}
          </Button>

          {bookingStatus.status == "DONT_CALL" &&
            bookingStatus.allowedTalkTime > 0 ? (
            <Button className="all_btn1" onClick={() => handleProceed()}>
              {t("USR.BOK.UR.PLN.PRCED")}
            </Button>
          ) : null}
        </Modal2.Footer>
      </Modal2>

      {/* <Modal2
        show={callType}
        backdrop="static"
        keyboard={false}
        onHide={closeCallType}
        className="all_border"
        centered
      >
        <Modal2.Header closeButton className="all_background">
          <h3>Call Type</h3>
        </Modal2.Header>
        <Row>
          <Col xs={2} sm={2} md={3}></Col>
          <Col xs={8} sm={8} md={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <div>
                <input
                  type="radio"
                  name="callType"
                  value="wallet"
                  onChange={(e) => handleProceedCall(e.target.value)}
                  style={{ marginRight: "5px" }}
                />
                <label>{t("USR.MIN.BASED")}</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="callType"
                  value="duration"
                  onChange={(e) => handleProceedCall(e.target.value)}
                  style={{ marginRight: "5px" }}
                />
                <label>{t("USR.DUR.BASED")}</label>
              </div>
            </div>
          </Col>
          <Col xs={2} sm={2} md={3}></Col>
        </Row>
        <Modal2.Footer className="d-flex justify-content-evenly">
          <Button className="all_btn1" onClick={closeCallType}>
            {t("TXT.CLO.LO")}
          </Button>
        </Modal2.Footer>
      </Modal2> */}

      <Modal2
        show={callType}
        backdrop="static"
        keyboard={false}
        onHide={closeCallType}
        centered
        fullscreen
      >
        <Modal2.Header closeButton className="all_background">
          <h3 className="mb-0">{t("USR.ALERT.HEAD")}</h3>
        </Modal2.Header>

        <Modal2.Body className="modal_bg_img">

          <Row className="g-4 justify-content-center">

            {/* FREE CALL */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleProceedCall("free")}
              >
                <img src={BgImg} alt="Free Call" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>{t("USR.FREE.CALL")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className={`circle-label ${i18n.language === "ta" ? "tamil-wallet-text" : ""}`}>
                    (2 {t("TXT.MIN.LO")})
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>
              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* WALLET CALL */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleProceedCall("wallet")}
              >
                <img src={BgImg} alt="Minute Call" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>{t("USR.MIN.CALL")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className={`circle-label ${i18n.language === "ta" ? "tamil-wallet-text" : ""}`}>
                    {t("USR.AMT.AVALABLE.TIME")} ₹{walletAmount}
                    <br />
                    {talkTime} {t("USR.MIN.TALK.TIME")}
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* 15 MIN */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleDurationRadio(15)}
              >
                <img src={BgImg} alt="15 Minutes" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>15 {t("USR.MIN.CALL.HEAD")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className="circle-label price">
                    <span className="old-price">₹250</span>
                    <span className="new-price">₹200</span>
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* 30 MIN */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleDurationRadio(30)}
              >
                <img src={BgImg} alt="30 Minutes" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>30 {t("USR.MIN.CALL.HEAD")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className="circle-label price">
                    <span className="old-price">₹500</span>
                    <span className="new-price">₹400</span>
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>

          </Row>

        </Modal2.Body>

        <Modal2.Footer className="justify-content-center">
          <Button className="all_btn1" onClick={closeCallType}>
            {t("TXT.CLO.LO")}
          </Button>
        </Modal2.Footer>

      </Modal2>

      <Row className="d-flex  g-1">
        {filteredPersons.length > 0 ? (
          <>
            {filteredPersons.map((i, j) => (
              <>
                {i.professionalAccountStatus == "ACTIVATE" ? (
                  <Col md={6} lg={4} key={j}>
                    <Card
                      className="d-flex professionalCard all_border"
                      key={i.consultantUuid}
                    >
                      <Card.Header className="all_border">
                        <div className="d-flex justify-content-between flex-row">
                          <strong>{i.consultantName}</strong>
                          <span
                            style={{ width: "max-content", cursor: "pointer" }}
                          >
                            <ReviewBadge
                              conUuid={i.consultantUuid}
                              conName={i.consultantName}
                              conImgUrl={i.imgUrl}
                              conRating={i.consultantRating}
                            />
                          </span>
                        </div>
                        <div
                          className="mt-2 gap-1"
                          style={{ display: "flex", flexDirection: "row" }}
                        >
                          <div>
                            {i.imgUrl ? (
                              <>
                                <img
                                  src={i.imgUrl}
                                  style={{
                                    borderRadius: "50%",
                                    height: "50px",
                                    width: "50px",
                                    objectFit: "cover",
                                  }}
                                />
                              </>
                            ) : (
                              <>
                                <img
                                  src={require("../images/noimage.jpg")}
                                  style={{
                                    borderRadius: "50%",
                                    height: "50px",
                                    width: "50px",
                                    objectFit: "cover",
                                  }}
                                />
                              </>
                            )}
                            <div className="mt-2">
                              <b>
                                <span>₹{i.ratePerMin}</span>&nbsp;
                              </b>
                              <del style={{ color: "red" }}>
                                {i.maxRate == 0
                                  ? null
                                  : `${i.maxRate}/${t("TXT.MIN.LO")}`}
                              </del>
                            </div>
                          </div>

                          <div
                            sm={9}
                            style={{
                              textAlign: "left",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <small
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <MdOutlineLanguage />
                              {i.knownLangugae},{i.extraLang}
                            </small>
                            <small
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <BiBadgeCheck />
                              {i.skills},{i.extraSkill}
                            </small>
                            <small>
                              <GrUserExpert />
                              {i.expYear}
                              {t("USR.HOM.CL.TEXT1")}
                            </small>
                            {i.profstatus === 1 &&
                              !freeCallStatus &&
                              i.freeCallMins > 0 &&
                              i.freeCallAccess ? (
                              <small
                                style={{ color: "green", fontWeight: "bold" }}
                              >
                                <span> {t("USR.FREE")} </span>

                                <OverlayTrigger
                                  key="top"
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-top`}>
                                      <span>
                                        {i.freeCallMins}&nbsp;
                                        {t("USR.MIN.FREE")}{" "}
                                      </span>
                                    </Tooltip>
                                  }
                                >
                                  <u
                                    style={{
                                      margin: "0px 5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      checkLoginAndGetConsultant(
                                        i.consultantUuid,
                                        i.consultantName,
                                        "freeCall",
                                        i.ratePerMin,
                                      );
                                    }}
                                  >
                                    {t("TXT.CAL.LO")}{" "}
                                  </u>
                                </OverlayTrigger>
                                <span style={{ margin: "0px 5px" }}>/</span>
                                {i.consultantUuid ==
                                  "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                                  i.consultantUuid ==
                                  "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                                  i.consultantUuid ==
                                  "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-top`}>
                                        <span>
                                          {i.freeCallMins}&nbsp;
                                          {t("USR.MIN.FREE")}{" "}
                                        </span>
                                      </Tooltip>
                                    }
                                  >
                                    <u
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        checkLoginAndGetConsultant(
                                          i.consultantUuid,
                                          i.consultantName,
                                          "freeChat",
                                          i.ratePerMin,
                                        );
                                      }}
                                    >
                                      {t("USR.CHAT.BTN")}
                                    </u>
                                  </OverlayTrigger>
                                )}
                              </small>
                            ) : null}
                          </div>
                        </div>
                      </Card.Header>
                      <Card.Body className="text-center">
                        <Row>
                          <Col
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <OverlayTrigger
                              key="top"
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  {t("TXT.STA.CALL.LO")}
                                </Tooltip>
                              }
                            >
                              <Button
                                className="mt-2 all_btn"
                                size="sm"
                                disabled={i.profstatus === 1 ? false : true}
                                // onClick={() => {
                                //   checkLoginAndGetConsultant(
                                //     i.consultantUuid,
                                //     i.consultantName,
                                //     "Call",
                                //     i.ratePerMin,
                                //   );
                                // }}
                                // onClick={() => {
                                //   if (!token) {
                                //     sessionStorage.setItem(
                                //       "openCallModal",
                                //       "true",
                                //     );
                                //     sessionStorage.setItem(
                                //       "consultantId",
                                //       i?.consultantUuid,
                                //     );
                                //     sessionStorage.setItem(
                                //       "consultantName",
                                //       i?.consultantName,
                                //     );

                                //     navigate("/login");
                                //     return;
                                //   }

                                //   sessionStorage.setItem(
                                //     "consultantId",
                                //     i?.consultantUuid,
                                //   );
                                //   sessionStorage.setItem(
                                //     "consultantName",
                                //     i?.consultantName,
                                //   );

                                //   openCallType();
                                // }}
                                onClick={async () => {

                                  if (!token) {
                                    sessionStorage.setItem("openCallModal", "true");
                                    sessionStorage.setItem("consultantId", i?.consultantUuid);
                                    sessionStorage.setItem("consultantName", i?.consultantName);

                                    navigate("/login");
                                    return;
                                  }

                                  sessionStorage.setItem("consultantId", i?.consultantUuid);
                                  sessionStorage.setItem("consultantName", i?.consultantName);

                                  await getWalletBalance(i?.ratePerMin);
                                  setTimeout(() => {
                                    openCallType();
                                  }, 100);
                                }}
                              >
                                {t("USR.HOM.CL.ACTION1")}
                              </Button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              key="top"
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  {t("TXT.DO.SCH.LO")}
                                </Tooltip>
                              }
                            >
                              <Button
                                className="mt-2 all_btn"
                                size="sm"
                                onClick={() => {
                                  checkLoginAndGetConsultant(
                                    i.consultantUuid,
                                    i.consultantName,
                                    "Book",
                                  );
                                }}
                              >
                                {t("USR.HOM.CL.ACTION2")}
                              </Button>
                            </OverlayTrigger>
                            {i.consultantUuid ==
                              "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                              i.consultantUuid ==
                              "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                              i.consultantUuid ==
                              "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                              <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    {t("USR.START.CHAT")}
                                  </Tooltip>
                                }
                              >
                                <Button
                                  className="mt-2 all_btn"
                                  size="sm"
                                  disabled={i.profstatus !== 1}
                                  onClick={() => {
                                    checkLoginAndGetConsultant(
                                      i.consultantUuid,
                                      i.consultantName,
                                      "Chat",
                                      i.ratePerMin,
                                    );
                                  }}
                                >
                                  {String(loadingId) ===
                                    String(i.consultantUuid) && (
                                      <span className="spinner-border spinner-border-sm me-2"></span>
                                    )}
                                  {t("USR.CHAT.BTN")}
                                </Button>
                              </OverlayTrigger>
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                      {i.profstatus === 1 ? (
                        <Card.Footer
                          className="text-center all_border"
                          style={{ color: "green", height: 45 }}
                        >
                          <strong>{t("USR.HOM.PR.ONL")}</strong>
                          &nbsp;
                          <Spinner
                            animation="grow"
                            variant="success"
                            size="sm"
                          />
                          {/* <GoProject color="RED" size={20} /> */}
                        </Card.Footer>
                      ) : null}
                      {i.profstatus === 2 ? (
                        <Card.Footer
                          className="text-center all_border"
                          style={{ color: "red", height: 45 }}
                        >
                          <strong>{t("USR.HOM.PR.OFF")}</strong>
                          &nbsp;
                          <GoProject color="RED" size={20} />
                        </Card.Footer>
                      ) : null}
                      {i.profstatus === 3 ? (
                        <Card.Footer
                          className="text-center all_border"
                          style={{ color: "green", height: 45 }}
                        >
                          <strong>{t("USR.HOM.PR.ONCA")}</strong>
                          &nbsp;
                          <Spinner
                            animation="grow"
                            variant="success"
                            size="sm"
                          />
                        </Card.Footer>
                      ) : null}
                    </Card>
                  </Col>
                ) : null}
              </>
            ))}
          </>
        ) : (
          <center>
            <h5>No Consultant Found</h5>
          </center>
        )}
      </Row>
    </div>
  );
};

const Search = ({ details }) => {
  const { walletBalance, setWalletBalance } = UseConsultant();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");
  const [searchField, setSearchField] = useState("");
  const [searchSkill, setSearchSkill] = useState("ALL");
  const [allLang, setAllLang] = useState([]);
  const [allSkill, setAllSkill] = useState([]);
  const [initialProf, setInitialProf] = useState(details);
  const [searchLang, setSearchLang] = useState("All");
  const [loading, setLoading] = useState(false);
  console.log("details", details);
  const [selectedConsultantService, setSelectedConsultantService] = useState();

  useEffect(() => {
    vasthuUrl
      .get(`vasthu/openapi/getskills`)
      .then((res) => {
        setAllSkill(res.data);
        console.log("all skills", res.data);
      })
      .catch((err) => {
        setAllSkill([]);
        alert("can't get Skills");
      });
    vasthuUrl
      .get("openapi/lang/allCode")
      .then((res) => {
        console.log("available lang", res.data);
        setAllLang(res.data);
      })
      .catch((err) => {
        setAllLang([]);
        alert("can't get lang");
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    try {
      vasthuUrl
        .post(`info/professional/byskillorlang`, {
          skill: searchSkill,
          langCode: searchLang,
        })
        .then((res) => {
          setInitialProf(res.data);
          setLoading(false);
          console.log("con filter out", res.data);
          if (searchSkill == "Vasthu Consultation") {
            setSelectedConsultantService(3);
          } else if (searchSkill == "Astrology Consultation") {
            setSelectedConsultantService(4);
          } else if (searchSkill == "Building Consultation") {
            setSelectedConsultantService(5);
          } else {
            setSelectedConsultantService();
          }
        });
    } catch (error) {
      setInitialProf((prev) => prev);
      setLoading(false);
      console.log("consultlist", error);
    }
  }, [searchSkill, searchLang]);

  const filteredPersons = initialProf.filter((person) => {
    return person.consultantName
      .toLowerCase()
      .includes(searchField.toLowerCase());
  });
  console.log("filteredPersonss", filteredPersons);

  const handleChange = (e) => {
    setSearchField(e.target.value);
  };
  const handleSkill = (e) => {
    setSearchSkill(e.target.value);
  };
  const handleLang = (e) => {
    setSearchLang(e.target.value);
  };

  return (
    <div className="border rounded all_background p-1">
      <center>
        <h1>{t("CM.CNSL.ON.TL")}</h1>
      </center>

      <h4>
        {token !== null ? (
          <b>
            {t("USR.AVABLE.BALCE")}: ₹ {walletBalance}
          </b>
        ) : null}
      </h4>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h6 className="d-block d-sm-none" style={{ color: "red" }}>
          {t("USR.WALT..BALCE.ALT.MSG")}
        </h6>

        <h4 className="d-none d-sm-block" style={{ color: "red" }}>
          {t("USR.WALT..BALCE.ALT.MSG")}
        </h4>
        <Button
          className="mt-2 all_btn"
          onClick={() => {
            if (token !== null) {
              navigate("/walletoffer");
            } else {
              window.sessionStorage.setItem("rerender", "walletoffer");
              navigate("/login");
            }
          }}
          style={{ float: "right" }}
        >
          {t("USR.RECHARGE")}
        </Button>
      </div>

      <div class="container">
        <div class="row d-flex justify-content-end align-items-center my-1">
          <div class="col-md-8 mt-2">
            <div class="form">
              <input
                type="text"
                class="form-control form-input form_feild"
                placeholder={t("CM.CNSL.SER.PL")}
                onChange={handleChange}
              />
            </div>
          </div>
          <div class="col-md-2 mt-2">
            <Form.Select
              value={searchSkill}
              className="form_feild"
              onChange={handleSkill}
            >
              <option value="ALL">{t("CM.CNSL.ON.SER1")}</option>

              {allSkill.map((i, j) => (
                <option
                  value={i.skillName}
                  // key={i.skillName}
                  key={j}
                >
                  {i.skillName}
                </option>
              ))}
            </Form.Select>
          </div>
          <div class="col-md-2 mt-2">
            <Form.Select
              value={searchLang}
              className="form_feild"
              onChange={handleLang}
            >
              <option value="ALL">{t("CM.CNSL.ON.SER2")}</option>
              {allLang.map((i, j) => (
                <option
                  value={i.langCode}
                  // key={i.id}
                  key={j}
                >
                  {i.language}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      </div>

      {/* {!loading ? ( */}
      <SearchList
        filteredPersons={filteredPersons}
        service={selectedConsultantService}
        wallet={walletBalance}
      />
      {/* // ) : (
      //   <center>
      //     <Spinner animation="border" />
      //   </center>
      // )} */}
    </div>
  );
};

export default Search;
